const BRANDS = [
  { id: "bridgestone", brand: "bridgestone", key: "BS" },
  { id: "firestone", brand: "firestone", key: "FS" },
];

function columnId(entry) {
  if (entry.id != null) {
    return String(entry.id);
  }

  return `rim-${entry.rim_size}-${entry.rim_size_operator}`;
}

function isAndMoreOperator(operator) {
  const op = String(operator ?? "").toLowerCase();
  return op === "gte" || op === "gt";
}

function toColumn(entry) {
  const rimSize = Number(entry.rim_size);

  return {
    id: columnId(entry),
    rimSize,
    andMore: isAndMoreOperator(entry.rim_size_operator),
  };
}

function readPoints(entry, brandKey) {
  const direct = entry.point_values?.[brandKey];
  if (direct != null && direct !== "") {
    return Number(direct);
  }

  const brandName = brandKey === "BS" ? "Bridgestone" : "Firestone";
  const byBrand = entry.point_values_by_brand?.[brandName];
  if (byBrand != null && byBrand !== "") {
    return Number(byBrand);
  }

  return null;
}

function formatPoints(value) {
  return value == null || Number.isNaN(value) ? "—" : value;
}

export function mapPointsPerTyresToSurchargeTable(entries) {
  if (!Array.isArray(entries) || entries.length === 0) {
    return null;
  }

  const items = entries
    .filter((entry) => entry.rim_size != null && !Number.isNaN(Number(entry.rim_size)))
    .map((entry) => ({ entry, ...toColumn(entry) }));

  if (items.length === 0) {
    return null;
  }

  const columns = items.map(({ id, rimSize, andMore }) => ({
    id,
    rimSize,
    andMore,
  }));

  const rows = BRANDS.map(({ id, brand, key }) => ({
    id,
    brand,
    points: items.map(({ entry }) => formatPoints(readPoints(entry, key))),
  }));

  if (!rows.some((row) => row.points.some((p) => p !== "—"))) {
    return null;
  }

  return { columns, rows };
}
